import React from "react";
import { Box, Flex, Text, HStack, Badge } from "@chakra-ui/react";
import { FaGraduationCap, FaPenNib } from "react-icons/fa";
import { ChapterHeading, Reveal, MotionBox, glass } from "./story";

const education = [
  {
    icon: FaGraduationCap,
    degree: "Master of Computer Applications (MCA)",
    school: "Indian Institute of Technology, Patna",
    period: "2024 to Present",
    status: "Pursuing",
    text: `Deepening my computer science foundations (algorithms, systems, and software design) at one of India's premier institutes, while I keep building in the real world.`,
  },
  {
    icon: FaPenNib,
    degree: "Bachelor of Computer Applications (BCA)",
    school: "CCSU University",
    period: "2018 to 2021",
    status: "Graduated",
    text: `Where the journey began. My first real exposure to programming, the web, and the joy of turning logic into something people can actually use.`,
  },
];

export default function Education() {
  return (
    <Box id="Education" py={{ base: "80px", md: "120px" }} px={{ base: "6%", md: "9%" }}>
      <ChapterHeading
        chapter="Chapter 02 · The Foundation"
        title="Where I learned to think"
        subtitle="Books and lecture halls that shaped how I break problems apart."
      />

      <Flex
        maxW="960px"
        mx="auto"
        gap="28px"
        direction={{ base: "column", md: "row" }}
      >
        {education.map((e, i) => (
          <Reveal key={i} delay={i * 0.15} flex="1">
            <MotionBox
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 250 }}
              {...glass({ p: { base: "24px", md: "30px" } })}
              h="100%"
            >
              <Flex justify="space-between" align="flex-start" mb="18px">
                <Flex
                  align="center"
                  justify="center"
                  w="52px"
                  h="52px"
                  borderRadius="14px"
                  bg="rgba(96,165,250,0.14)"
                  color="#60A5FA"
                >
                  <e.icon size="24px" />
                </Flex>
                <Badge
                  bg={e.status === "Pursuing" ? "#60A5FA" : "rgba(255,255,255,0.08)"}
                  color={e.status === "Pursuing" ? "white" : "#98a2b8"}
                  borderRadius="full"
                  px="12px"
                  py="4px"
                  fontSize="10px"
                  letterSpacing="0.1em"
                >
                  {e.status}
                </Badge>
              </Flex>

              <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="800" color="#f0f2f7">
                {e.degree}
              </Text>
              <HStack mt="6px" color="#60A5FA" fontWeight="600" fontSize="sm">
                <Text>{e.school}</Text>
              </HStack>
              <Text fontSize="xs" color="#7d879c" mt="2px" letterSpacing="0.05em">
                {e.period}
              </Text>
              <Text mt="16px" color="#c2c9d6" fontSize="sm" lineHeight="1.85">
                {e.text}
              </Text>
            </MotionBox>
          </Reveal>
        ))}
      </Flex>
    </Box>
  );
}
